export const DATE_FORMAT = 'YYYY-MM-DD';
export const PICKER_DATE_FORMAT = 'MMM DD, YYYY';
export const DATE_TIME_FORMAT = 'MMM DD, HH:mm';
export const TIMER_FORMAT = 'HH:mm:ss';
